export const IMAGE_HEIGHT = 107;
export const IMAGE_WIDTH = 160;

export const SHORTLIST_CHECKBOX_SIZE = 16;
export const LIST_TYPE_LABEL_SIZE = 10;

export const SGCM_IMAGE_URL = 'https://i.i-sgcm.com/new_cars/cars';
